export default __webpack_public_path__ + "static/media/IMG_4303_Original.81ef02d9.jpg";